// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const doughnutChartConstants = {
  codeSecretIssues: 'code secret issues',
  totalIssues: 'total issues',
  errorMessage: 'No data available',
};
